import styled, { css } from 'styled-components';
import { Size as ButtonSize } from '../../theme/Button';
import { Size as IconSize } from '../../theme/Icon';
import { getFontStyle } from '../../utils';
import { rem } from '../../utils/index';
export const SelectiveButtonSize = {
    XSmall: ButtonSize.XSmall,
    Small: ButtonSize.Small,
    Medium: ButtonSize.Medium,
    Large: ButtonSize.Large,
    XLarge: ButtonSize.XLarge,
};
export const getSelectiveButtonSize = ({ variant = 'default', size = 'Medium', }) => {
    const height = SelectiveButtonSize[size]
        ? rem(SelectiveButtonSize[size])
        : 'auto';
    return css `
    height: ${height};
  `;
};
export const getBadgePosition = ({ position = 'top-right', size = 'Small', }) => {
    const shift = rem(IconSize[size] / 2);
    return css `
    ${() => {
        switch (position) {
            case 'top-right':
                return `
            right: -${shift};
            top: -${shift};
          `;
            case 'top-left':
                return `
            left: -${shift};
            top: -${shift};
          `;
        }
        return '';
    }}
  `;
};
export const StyledButtonsWrapper = styled.div `
  display: flex;
  width: fit-content;
  position: relative;
`;
export const StyledSelectiveButton = styled.button `
  background: ${({ theme }) => theme.Color.Neutrals.Paper};
  box-sizing: border-box;
  border-radius: ${({ theme }) => rem(theme.Border.Radius.Medium)};
  border: 1px solid
    ${({ theme, isActive }) => isActive ? theme.Color.Brand.Primary : theme.Color.Neutrals.Border};
  cursor: pointer;
  display: inline-flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  ${getFontStyle('Small')}
  padding: ${({ theme }) => `${rem(theme.Spacing.Size.Small)}`};
  user-select: none;
  transition: all ${({ theme }) => theme.Transition.Timing.Out};
  ${({ variant, size }) => getSelectiveButtonSize({ variant, size })};

  &.disabled {
    pointer-events: none;
  }
`;
export const StyledBadge = styled.button `
  position: absolute;
  ${({ position, size }) => getBadgePosition({ position, size })};
  background: ${({ theme }) => theme.Color.Neutrals.Paper};
  height: ${({ theme }) => `${rem(theme.Icon.Size.XSmall)}`};
  width: ${({ theme }) => `${rem(theme.Icon.Size.XSmall)}`};
  border-radius: ${({ theme }) => `${rem(theme.Border.Radius.Large)}`};
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid ${({ theme }) => theme.Color.Feedback.Alert};
  padding: ${({ theme }) => `${rem(theme.Spacing.Size.XXSmall)}`};
  cursor: pointer;
`;
//# sourceMappingURL=SelectiveButton.style.js.map